import { Link } from "react-router-dom";
import { Reveal } from "@/components/Motion";
import BookButton from "@/components/BookButton";
import { useLang } from "@/i18n";

export default function CTABanner() {
  const { t } = useLang();
  return (
    <section data-testid="cta-banner" className="relative overflow-hidden bg-obsidian py-24 lg:py-32">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-gold/10 blur-[120px]" />
      <div className="relative mx-auto max-w-4xl px-6 text-center sm:px-12">
        <Reveal>
          <p className="overline text-gold">{t("cta.overline")}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-serif text-3xl leading-[1.15] tracking-tight text-white sm:text-4xl lg:text-5xl">
            {t("cta.title")}
          </h2>
        </Reveal>
        <Reveal delay={0.2} className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <BookButton testid="cta-book-consultation-button" />
          <Link to="/contact" data-testid="cta-request-quote-button" className="btn-outline-light">
            {t("cta.quote")}
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
